import { render, staticRenderFns } from "./ElButtonSubmit.vue?vue&type=template&id=50d4ffb3&scoped=true"
import script from "./ElButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ElButtonSubmit.vue?vue&type=script&lang=js"
import style0 from "./ElButtonSubmit.vue?vue&type=style&index=0&id=50d4ffb3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4ffb3",
  null
  
)

export default component.exports